"use client";

import { MutableRefObject, createContext, useContext } from "react";
export interface ChatMessagesHandle {
  scrollToBottom: (smooth?: boolean) => void;
}
export interface ChatScrollRefContextValue {
  chatMessagesRef: MutableRefObject<ChatMessagesHandle | null>;
}
export const ChatScrollRefContext = createContext<ChatScrollRefContextValue | null>(null);
export function useChatScrollRefContext() {
  const context = useContext(ChatScrollRefContext);
  if (!context) {
    throw new Error("useChatScrollRefContext must be used within a ChatScrollRefProvider");
  }
  return context;
}